import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortDirection } from '../../../common/enum';
import { ImageDTO, PaginationParams } from '../../types/apiType';

export interface Contributor {
  id: string;
  firstName: string;
  lastName: string;
}

export interface BookFilter {
  id: string;
  name: string;
}

export interface ImageState {
  currentImage: ImageDTO | null;
  list: ImageDTO[];
  pagination: PaginationParams;
  loading: boolean;
  contributors: Contributor[];
  books: BookFilter[];
  selectedImages: string[];
}

const initialState: ImageState = {
  list: [],
  currentImage: null,
  pagination: {
    pageNumber: 0,
    sortBy: ['created_at', 'filename'],
    sortDirection: [SortDirection.DESC, SortDirection.NONE],
    filterKey: {},
  },
  contributors: [],
  loading: false,
  selectedImages: [],
  books: [],
};

export const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    setCurrentImage: (state, action: PayloadAction<ImageDTO>) => {
      state.currentImage = action.payload;
    },
    setImages: (state, action: PayloadAction<ImageDTO[]>) => {
      state.list = action.payload;
    },
    setPagination: (state, action: PayloadAction<PaginationParams>) => {
      state.pagination = action.payload;
    },
    setImage: (state, action: PayloadAction<Partial<ImageDTO>>) => {
      const index = state.list.findIndex((image) => image.filename === action.payload.filename);
      if (state.list[index]) {
        state.list[index] = { ...state.list[index], ...action.payload };
      }
    },
    setImageLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContributor: (state, action: PayloadAction<Contributor[]>) => {
      state.contributors = action.payload;
    },
    setSelectedImages: (state, action: PayloadAction<string[]>) => {
      state.selectedImages = action.payload;
    },
    setBookFilters: (state, action: PayloadAction<BookFilter[]>) => {
      state.books = action.payload;
    },
  },
});

export const { setCurrentImage, setImages, setPagination, setImage, setImageLoading, setContributor, setSelectedImages, setBookFilters } =
  imageSlice.actions;

export default imageSlice.reducer;
